import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export const CTAFooter = () => {
  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-r from-slate-900 to-slate-800">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-3xl sm:text-4xl font-bold text-white mb-4">
          Ready to Lighten the Load?
        </h2>
        <p className="text-lg sm:text-xl text-white mb-8 max-w-2xl mx-auto">
          Book a 15-minute demo and see Gia automate intake and screen— in real time.
        </p>
        <Button 
          size="lg" 
          variant="secondary"
          className="bg-white text-slate-900 hover:bg-gray-100 hover:text-slate-900"
          onClick={() => window.open('https://calendly.com/david-scienzahealth/product-demo', '_blank')}
        >
          Book My Demo
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>
    </section>
  );
};